import {
  Card, Container, Typography, Button as MuiButton,
  Grid,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { newsUrl } from '@sda/utils/url';
import TicketMobileImage from './ticket-mobile.png';
import TicketDesktopLeftImage from './ticket-desktop-1.png';
import TicketDesktopRightImage from './ticket-desktop-2.png';

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: 0,
    backgroundColor: theme.palette.secondary.xlight,
    padding: theme.spacing(4, 0, 4, 0),
    position: 'relative',

    [theme.breakpoints.down('md')]: {
      height: 'auto',
      aspectRatio: 0.8,
      width: '100%',
    },

    [theme.breakpoints.up('md')]: {
      borderRadius: theme.radii.large,
      display: 'flex',
      alignItems: 'center',
      height: theme.spacing(46),
      width: `calc(100% - ${theme.spacing(6)})`,
      marginLeft: `${theme.spacing(3)} !important`,
      marginRight: `${theme.spacing(3)} !important`,
      padding: theme.spacing(3),
    },
  },
  container: {
    zIndex: 2,
    position: 'relative',
  },
  heading: {
    marginBottom: theme.spacing(3),
  },
  imageContainer: {
    position: 'relative',
  },
  image: {
    position: 'relative',
    width: '100%',
  },
  imageLeft: {
    bottom: theme.spacing(9 * -1),
  },
  imageRight: {
    top: theme.spacing(9 * -1),
  },
  mobileTicketImage: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    width: '100%',
  },
}));

export const TicketingBlock = () => {
  const { classes, cx } = useStyles();
  const isMobile = useIsMobile();

  return (
    <Card className={classes.root}>
      {Boolean(isMobile) && (
        <img
          src={TicketMobileImage}
          loading="lazy"
          alt="ticketing preview"
          className={classes.mobileTicketImage}
        />
      )}

      <Container
        maxWidth="md"
        className={classes.container}
      >
        <Grid
          container
          spacing={3}
          alignItems="center"
        >
          <Grid
            item
            xs={12}
            md={6.75}
          >
            <Typography
              variant={isMobile ? 'h6' : 'h4'}
              sx={{ color: 'secondary.dark' }}
              className={classes.heading}
            >
              Keep 100% of your ticket revenue with our commission-free platform.
              Simple setup, powerful results.
            </Typography>

            <MuiButton
              color="secondary"
              variant="contained"
              href={newsUrl('/pricing')}
            >
              Explore Pricing
            </MuiButton>
          </Grid>

          {!isMobile && (
            <Grid
              item
              container
              md={5.25}
              spacing={2}
            >
              <Grid
                item
                md={6}
                className={classes.imageContainer}
              >
                <img
                  src={TicketDesktopLeftImage}
                  loading="lazy"
                  alt="ticketing preview"
                  className={cx(classes.image, classes.imageLeft)}
                />
              </Grid>

              <Grid
                item
                md={6}
                className={classes.imageContainer}
              >
                <img
                  src={TicketDesktopRightImage}
                  loading="lazy"
                  alt="revenue splitting preview"
                  className={cx(classes.image, classes.imageRight)}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Container>
    </Card>
  );
};
